import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';

export const StickyBarContainer = styled.div<{
  isStuck: boolean;
  isMakePhotoPreviewMoreProminent?: boolean;
}>`
  ${(props) =>
    props.isStuck &&
    `
    background: ${COLORS3.WHITE_100};
    border-bottom: 1px solid ${COLORS3.BLACK_030};
    padding: ${SPACING.S24};
    margin: 0 -${SPACING.S24};

    ${MEDIA_QUERY_V2.MOBILE} {
        padding: ${props.isMakePhotoPreviewMoreProminent ? SPACING.S16 : SPACING.S24};
    }
  `}
`;

export const Summary = styled.div<{ isMakePhotoPreviewMoreProminent?: boolean }>`
  ${FONTS.textSizeCompact(FONTS.SIZE.SMALL)}
  margin-top: ${(props) => (props.isMakePhotoPreviewMoreProminent ? SPACING.S8 : SPACING.S16)};

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Links = styled.div`
  display: flex;
  column-gap: ${SPACING.S16};
`;
